import FormElements from "./_form-elements";

class Login {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", () => {
            new FormElements();
        });
    }
}

new Login();
